import { BaseComponent } from '../../../../shared/base-classes/base.component';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ISftpSettingsListFilters } from '../sftp-settings-list-models/sftp-settings-list-filters.interface';

@Component({
  selector: 'app-sftp-settings-list-filters',
  templateUrl: './sftp-settings-list-filters.template.html',
  styleUrls: ['./sftp-settings-list-filters.scss']
})
export class AppSftpSettingsListFilters extends BaseComponent {
  @Input() filters: ISftpSettingsListFilters;
  @Output() filtersUpdated: EventEmitter<ISftpSettingsListFilters>;

  constructor() {
    super();
    this.filtersUpdated = new EventEmitter<ISftpSettingsListFilters>();
  }
}
